var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAP0lEQVR42mMYBaNgKID/Av8FKNN+HggFKNEOBCAjyNd+HkoKkKtdAMEiSzsqjyztZBiBUIxp6GjCHgWjYPACAEALWoP9zZnpAAAAAElFTkSuQmCC";
  export default img;